import { render, staticRenderFns } from "./CNewsItem.vue?vue&type=template&id=20099ec4&"
import script from "./CNewsItem.vue?vue&type=script&lang=ts&"
export * from "./CNewsItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports